import React from "react";
import TemplateView from "../../TemplateView";

function View(props) {
    return (
        <TemplateView
            group="Master"
            subgroup="Cabang"
        />
    );
};

export default View;